/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 01/20/2021
 *
 * @version 0.1
 * Revisions:
 * 01/20/2021 - BW - Initial Creation
 *
 * Description/Purpose:
 * Payment Profile Expiration Date
 * Code that will control the Expiration Date
 ************************************************************** */
import { COMMON } from "page/payment/payment-profile-util";
import StackTraceError from "component/stack-trace-error/stack-trace-error";


const PaymentProfileExpirationDate = {


  /**
     * Init function
     * @param options
     * @returns {PaymentProfileExpirationDate}
     */
  init($form, options) {
    this._$form = $form;
    const defaults = {};
    // extends config
    this.opts = $.extend(true, defaults, options);

    this._setUpVariable();
    this._cacheDom();
    this._registerEvent();
    return this;
  },


  /**
     * Setup some common vars
     */
  _setUpVariable() {
    return this;
  },


  /**
     * Caches some often used DOM objects
     * @private
     */
  _cacheDom() {
  },


  /**
     * Register events or DOM event
     * @private
     */
  _registerEvent() {
    try {
      const _this = this;
      $(`${COMMON.PAYMENT_PROFILE_MODAL_PAYMENT_PROFILE_CONTAINER_ITEM_CLASS} `
                + `.${COMMON.PAYMENT_PROFILE_MODAL_EXPIRES_INPUT}`)
        .each((index, value) => {
          $(value).on('textchange',
            ($event, previousText) => _this._onExpirationDateChange($event, previousText));
        });
    } catch (e) {
      StackTraceError.processError(e, 'Payment Profile - Register Event');
    }
  },

  /**
     * Will check and control the text entered for the expirationDate
     * @param event
     * @param previousText
     * @returns
     */
  _onExpirationDateChange(event, previousText) {
    const $elem = $(event.currentTarget);

    // See if we can add a beginning user to help the user
    if (this._checkMonthExpirationDateFormat($elem, event, previousText)) {
      $elem.val(`0${$elem.val()}`);
    }

    // Check to see if the user's format matches a month and if so add the forward slash
    if (this._checkForwardSlashExpirationDateFormat($elem, event, previousText)) {
      $elem.val(`${$elem.val()}/`);
    }
  },


  /**
     * Forward Slash expiration test
     * @param $elem
     * @param event
     * @returns
     */
  _checkMonthExpirationDateFormat($elem, event, previousText) {
    // console.log($elem.val().length);
    /* eslint-disable no-useless-escape */
    if ($elem.val().length === 1 && previousText.length === 2 && previousText.endsWith('\d')) return false;
    /* eslint-disable no-useless-escape */
    return $elem.val().match(/^([2-9])$/);
  },


  /**
     * Month expiration test
     * @param $elem
     * @param event
     * @returns
     */
  _checkForwardSlashExpirationDateFormat($elem, event, previousText) {
    // console.log($elem.val().length);
    if ($elem.val().length === 2 && previousText.length === 3 && previousText.endsWith("/")) return false;
    return $elem.val().match(/^(((0)[0-9])|((1)[0-2]))$/);
  },


};
export default PaymentProfileExpirationDate;
